module.exports = __webpack_public_path__ + "img/mc-r-n1.88dbd282.gif";